<template>
  <a-modal  title="提交对帐单" style="top: 20px;"
           :width="1000"  v-model="enterprisesubmitible" footer=''>
    <a-form layout="inline" :form="form">
    <div  v-if="this.StatementRreceiver">
      <!--   江苏锁安科技有限公司 2020年2月对帐单  表头-->
      <a-row>
        <a-col >
          <h2 style="text-align:center;margin: 20px 0">{{this.StatementRreceiver.majorStatementName}}</h2>
          <h5 style="text-align: center">{{this.StatementRreceiver.subStatementName}}</h5>
        </a-col>
      </a-row>
      <a-row style="padding-top: 20px" >
        <a-col :span="6"></a-col>
        <a-col :span="10"  ><a-form-item label="发送给" >
          <a-checkbox-group
            v-decorator="['outercheckbox',{rules: [ { required: true, message: '请选择接收人!', type: 'array' }]}, { initialValue: [] }]"
            style="width: 100%;" @change="outeronChangegroup"
          >
            <a-row v-for="(item,index) in StatementRreceiver[1]" >
              <a-col :span="12">
                <a-checkbox :value="item.receiver">
                  {{item.name}}
                </a-checkbox>
                <!--<a-input disabled v-model="item.role"/>-->
                <br />
              </a-col>
              <a-col :span="12" >
                <a-input disabled v-model.trim="item.role"/>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </a-form-item></a-col>
        <a-col :span="8" ><a-form-item label="抄送给" >
          <a-checkbox-group
            v-decorator="['innercheckbox',{rules: [ { required: true, message: '请选择接收人!', type: 'array' }]}, { initialValue: ['1'] }]"
            style="width: 100%;" @change="inneronChangegroup"
          >
            <a-row v-for="(item,index) in StatementRreceiver[0]" >
              <a-col >
                <a-checkbox :value="item.receiver">
                  {{item.name}}
                </a-checkbox>
                <br />
              </a-col>
            </a-row>
          </a-checkbox-group>
        </a-form-item></a-col>

      </a-row>
      <a-row style="text-align:center;margin-top: 30px">
        <a-col :span="12" >
          <a-col :span="4"></a-col>
          <a-col :span="12" >
            <a-row  >
              <a-col :span="6" style="display: block;width: 300px;padding-left:5px ;height:
          200px">
                <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin: 20px;">
                  <!--{ rules: [{ required: true, message: '请输入备注信息!' }] }-->
                  <a-input  type="textarea" style="width: 580px;margin-left: 6px;"
                           v-decorator="['remark']"/>
                </a-form-item>
              </a-col>
            </a-row>
          </a-col>
        </a-col>
      </a-row>
      <a-col style="text-align:center;margin: 40px 0">
        <a-button type="primary"  @click="determine">确定</a-button>
        <a-button style="margin-left: 8px;" @click="cancel">取消</a-button>
      </a-col>
    </div>
    </a-form>
  </a-modal>

</template>

<script>
  import {getDictMap} from "../../../utils/dict";
  import pick from 'lodash.pick'
  import { getFinanceSubmit} from '@/api/finance/EnterpriseSubmit'
  export default {
    name: "EnterpriseSubmit",
    data() {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        majorStatementId:'',
        subStatementIds:[],
        checkedList:[],
        enterprisesubmitible:false,
        form: this.$form.createForm(this),
        StatementRreceiver:'',
        subStatementName:'',
        majorStatementName:'',
        outerReceivers:[],
        innerReceivers:[],
      };
    },
    // 下拉框的选项
    async created () {

      // 字典为安装类型
      this.installTypes = [];
      this.restaurantOperTypeMap = await getDictMap('pay_method');
      this.restaurantOperTypeMap.forEach((value, key) => {
        this.installTypes.push({code: key, label: value})
      })
      // 字典为分单方式
      // this.plainOptions = [];
      // this.restaurantOperTypeMap = await getDictMap('seperate_order_method');
      // this.restaurantOperTypeMap.forEach((value, key) => {
      //   this.plainOptions.push({value: key, label: value})
      // })
    },
    methods: {
      cancel(){
        this.enterprisesubmitible=false
      },
      showenterprisesubmit(StatementRreceiver){
        // this.$emit('ok')
        this.enterprisesubmitible=true
        this.StatementRreceiver=StatementRreceiver
        // console.log(StatementRreceiver)
        this.form.resetFields()
        this.form.setFieldsValue({
          outercheckbox: '',
          innercheckbox: '',
        })

        this.$nextTick(() => {
          this.form.setFieldsValue(pick(StatementRreceiver,
            'remark'))
        })
      },
      outeronChangegroup(checkedValues) {
        this.outerReceivers=checkedValues
      },
      inneronChangegroup(checkedValues) {
     this.innerReceivers=checkedValues
      },
      determine(){
        this.form.validateFields((err, values) => {
          if (!err) {
            getFinanceSubmit({
              "innerReceivers": this.innerReceivers?this.innerReceivers:[],
              "majorStatementId": this.StatementRreceiver.majorStatementId,
              "outerReceivers": this.outerReceivers?this.outerReceivers:[],
              "subStatementIds": this.StatementRreceiver.subStatementIds
            }).then(res => {
              if (res.code === 0) {
                this.$message.success('操作成功');
                this.$emit('ok')
                this.enterprisesubmitible=false
              } else {
                this.$message.error(res.msg);
              }
            })
          }
        });

      }

    },
  }
</script>

<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td {  white-space: nowrap;padding: 4px 16px;}

</style>